<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
            <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/academics/academic-calendar-create"><i class="fas fa-plus"></i> {{ "ADD" | translate |
                titlecase }}</button>
        </div>

        <div class="col-12">

            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "ACADEMIC_CALENDAR" | translate | titlecase }}</h5>

                <app-loader [show]="showLoader"></app-loader>

                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <table *ngIf="calendars.length >= 1" class="table-striped" id="datatable">
                        <thead>
                            <tr>
                                <th>{{ "ID" | translate | titlecase }}</th>
                                <th>{{ "EFFECTIVE_DATE_FROM" | translate | titlecase }}</th>
                                <th>{{ "EFFECTIVE_DATE_TO" | translate | titlecase }}</th>
                                <th>{{ "TYPE" | translate | titlecase }}</th>
                                <th>{{ "REPEATS" | translate | titlecase }}</th>
                                <th>{{ "FREQUENCY" | translate | titlecase }}</th>
                                <th>{{ "REMARKS" | translate | titlecase }}</th>
                                <th>{{ "ACTIVE" | translate | titlecase }}</th>
                                <th class="border-0 font-14 px-2 text-grey">{{ "MODIFY" | translate | titlecase
                                    }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of calendars">
                                <td>{{res?.id}}</td>
                                <td>{{res?.effectiveFrom | date}}</td>
                                <td>{{res?.effectiveTo | date}}</td>
                                <td>{{
                                    (globals.lang == 'ar')? res?.typeNameAr : res?.typeNameEn
                                }}</td>
                                <td>{{res?.repeatsFlag}}</td>
                                <td>{{res?.frequency}}</td>
                                <td>{{res?.remarks}}</td>
                                <td>{{(res?.active == 'YES')? ('YES' | translate | titlecase) : ('NO' | translate |
                                    titlecase) }}</td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-warning" routerLink="/academics/academic-calendar-update"
                                        [queryParams]="{calendarId: res?.id}"><i class="fas fa-edit"></i>
                                        {{ "MODIFY" | translate | titlecase }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>